export default __webpack_public_path__ + "static/media/guesty_step5.dd54d1c4.png";